<template>
  <v-main>
    <div id="start" v-if="status == 1">
      <section class="last">
        <div class="scInr">
          <div class="ContentTitle pt-6">
            <h2 class="head01" data-text="Contact">資料請求・来場予約</h2>
            <div class="titleafter">
              <img src="/image/title.png" />
            </div>
          </div>
          <p>
            <span class="Req">[※必須]</span
            >は、必須項目です。記入漏れがないか確認の上、ご送信ください。 <br />
            お送りいただく情報は、SSL(セキュア・ソケット・レイヤー)暗号化技術により保護されております。
          </p>
          <p class="YellowBox btm15">先にお選びください。</p>
          <v-form name="form" id="form" ref="form">
            <div class="bscTbl01 btm30">
              <table width="100%" border="0">
                <tbody>
                  <tr class="last">
                    <th scope="row" class="w30 pb-5">
                      選択項目<span class="Req">[※必須]</span>
                    </th>
                    <td>
                      <div class="fltList02">
                        <ul>
                          <v-radio-group
                            row
                            v-model="sentaku"
                            required
                            :rules="[required]"
                          >
                            <li class="inlinebk pr30 first">
                              <v-radio
                                label="資料請求"
                                color="primary"
                                value="資料請求"
                              ></v-radio>
                            </li>
                            <li class="inlinebk even last">
                              <v-radio
                                label="来場予約"
                                color="cyan lighten-1"
                                value="来場予約"
                              ></v-radio>
                            </li>
                          </v-radio-group>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="YellowBox btm15">お客様情報のご入力をお願いします。</p>

            <div class="bscTbl01 btm30">
              <table width="100%" border="0">
                <tbody>
                  <tr id="firstNotice" v-show="sentaku == '来場予約'">
                    <th scope="row" class="w30 pb-5">
                      来場希望日<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc">
                      <div class="fltList02">
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="date"
                              label="第１希望"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :rules="[required_if_raijyou]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="date"
                            locale="jp-ja"
                            @input="menu = false"
                            :allowed-dates="allowedDate"
                            :day-format="(date) => new Date(date).getDate()"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu = false">
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu.save(date)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <v-row>
                        <v-col cols="5">
                          <div class="ml-2">
                            <v-select
                              :items="hh_lists"
                              v-model="hh1"
                              label="時"
                              dense
                              outlined
                              :rules="[required_if_raijyou]"
                            ></v-select>
                          </div>
                        </v-col>
                        <v-col cols="5">
                          <div class="ml-0">
                            <v-select
                              :items="mm_lists"
                              v-model="mm1"
                              label="分"
                              dense
                              outlined
                              :rules="[required_if_raijyou]"
                            ></v-select>
                          </div>
                        </v-col>
                      </v-row>
                      <div class="fltList02">
                        <v-menu
                          ref="menu2"
                          v-model="menu2"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="date2"
                              label="第２希望"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :rules="[required_if_raijyou]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="date2"
                            locale="jp-ja"
                            @input="menu2 = false"
                            :allowed-dates="allowedDate"
                            :day-format="(date) => new Date(date).getDate()"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu2 = false">
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu2.save(date)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <v-row>
                        <v-col cols="5">
                          <div class="ml-2">
                            <v-select
                              :items="hh_lists"
                              v-model="hh2"
                              label="時"
                              dense
                              outlined
                              :rules="[required_if_raijyou]"
                            ></v-select>
                          </div>
                        </v-col>
                        <v-col cols="5">
                          <div class="ml-0">
                            <v-select
                              :items="mm_lists"
                              v-model="mm2"
                              label="分"
                              dense
                              outlined
                              :rules="[required_if_raijyou]"
                            ></v-select>
                          </div>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                  <tr class="even">
                    <th scope="row" class="pb-5">
                      お名前<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc">
                      <p class="btm5">
                        <span
                          ><v-text-field
                            v-model="sei"
                            label="姓"
                            placeholder="姓"
                            dense
                            outlined
                            :rules="[required, limit_20]"
                          ></v-text-field
                        ></span>
                        <span
                          ><v-text-field
                            v-model="mei"
                            label="名"
                            placeholder="名"
                            dense
                            outlined
                            :rules="[required, limit_20]"
                          ></v-text-field
                        ></span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="pb-5">
                      フリガナ<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc">
                      <p class="btm5">
                        <span
                          ><v-text-field
                            v-model="sei_kana"
                            label="セイ"
                            placeholder="セイ"
                            dense
                            outlined
                            :rules="[required, limit_20]"
                          ></v-text-field></span
                        ><span
                          ><v-text-field
                            v-model="mei_kana"
                            label="メイ"
                            placeholder="メイ"
                            dense
                            outlined
                            :rules="[required, limit_20]"
                          ></v-text-field
                        ></span>
                      </p>
                    </td>
                  </tr>
                  <tr class="even">
                    <th scope="col" class="pb-5">
                      ご住所<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc pb-n16">
                      <dl>
                        <dt>郵便番号</dt>
                        <dd>
                          <v-text-field
                            v-model="zipcode"
                            label="郵便番号"
                            placeholder="半角数字で入力してください"
                            dense
                            outlined
                            @blur="getaddress()"
                            :rules="limit_7"
                          ></v-text-field>
                        </dd>
                      </dl>
                      <dl>
                        <dt>都道府県</dt>
                        <dd>
                          <v-select
                            v-model="addr1"
                            :items="todoufuken_list"
                            label="都道府県"
                            dense
                            outlined
                            :rules="[required]"
                          ></v-select>
                        </dd>
                      </dl>
                      <dl>
                        <dt>市区</dt>
                        <dd>
                          <v-text-field
                            v-model="addr2"
                            label="市区"
                            placeholder="市区"
                            dense
                            outlined
                            :rules="[required]"
                          ></v-text-field>
                        </dd>
                      </dl>
                      <dl>
                        <dt>丁目番地号</dt>
                        <dd>
                          <v-text-field
                            v-model="addr3"
                            label="丁目番地号"
                            placeholder="丁目番地号"
                            dense
                            outlined
                            :rules="[required]"
                          ></v-text-field>
                        </dd>
                      </dl>
                      <dl>
                        <dt>建物名・号室</dt>
                        <dd>
                          <v-text-field
                            v-model="addr4"
                            label="建物名・号室"
                            placeholder="建物名・号室"
                            dense
                            outlined
                          ></v-text-field>
                        </dd>
                      </dl>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="pb-5">
                      お電話番号<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc">
                      <v-text-field
                        v-model="tel"
                        label="お電話番号"
                        placeholder="（半角入力）"
                        dense
                        outlined
                        :rules="numberonly"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr class="even">
                    <th scope="row" class="pb-5">
                      メールアドレス<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc">
                      <v-text-field
                        v-model="email"
                        label="メールアドレス"
                        placeholder="（半角入力）"
                        dense
                        outlined
                        :rules="emailonly"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="pb-5">
                      年齢<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc">
                      <v-text-field
                        v-model="age"
                        label="年齢"
                        placeholder="（半角入力）"
                        dense
                        outlined
                        :rules="numberonly"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr class="even last">
                    <th scope="row" class="w30 pb-5">
                      このホームページをどのようにお知りになりましたか？
                      <br />※複数選択<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc">
                      <ul class="inlinebk pr30 vAT">
                        <li class="ttl first">
                          <p>■インターネット</p>
                        </li>
                        <li class="even">
                          <v-checkbox
                            v-model="selected_known"
                            label="Yahoo!検索"
                            value="Yahoo!検索"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li>
                          <v-checkbox
                            v-model="selected_known"
                            label="Google検索"
                            value="Google検索"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li class="even">
                          <v-checkbox
                            v-model="selected_known"
                            label="その他検索"
                            value="その他検索"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li>
                          <v-checkbox
                            v-model="selected_known"
                            label="バナー広告"
                            value="バナー広告"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li class="even">
                          <v-checkbox
                            v-model="selected_known"
                            label="メールマガジン"
                            value="メールマガジン"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li>
                          <v-checkbox
                            v-model="selected_known"
                            label="SUUMOネット"
                            value="SUUMOネット"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li class="even">
                          <v-checkbox
                            v-model="selected_known"
                            label="Yahoo!不動産"
                            value="Yahoo!不動産"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li>
                          <v-checkbox
                            v-model="selected_known"
                            label="LIFULL HOME'S"
                            value="LIFULL HOME'S"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li class="even">
                          <v-checkbox
                            v-model="selected_known"
                            label="at home"
                            value="at home"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li class="last">
                          <v-checkbox
                            v-model="selected_known"
                            label="その他インターネット"
                            value="その他インターネット"
                            hide-details
                          ></v-checkbox>
                        </li>
                      </ul>
                      <ul class="inlinebk pr30 vAT">
                        <li class="ttl first">
                          <p>■紙媒体</p>
                        </li>
                        <li class="even">
                          <v-checkbox
                            v-model="selected_known"
                            label="新聞折込チラシ"
                            value="新聞折込チラシ"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li>
                          <v-checkbox
                            v-model="selected_known"
                            label="ポスト投函チラシ"
                            value="ポスト投函チラシ"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li class="even">
                          <v-checkbox
                            v-model="selected_known"
                            label="街頭配布チラシ"
                            value="街頭配布チラシ"
                            hide-details
                          ></v-checkbox>
                        </li>
                        <li class="last">
                          <v-checkbox
                            v-model="selected_known"
                            label="新聞紙面広告"
                            value="新聞紙面広告"
                            hide-details
                          ></v-checkbox>
                        </li>
                      </ul>
                      <ul class="inlinebk pr30 vAT">
                        <li class="first">
                          <ul>
                            <li class="ttl first">
                              <p>■看板</p>
                            </li>
                            <li class="even">
                              <v-checkbox
                                v-model="selected_known"
                                label="販売センター看板"
                                value="販売センター看板"
                                hide-details
                              ></v-checkbox>
                            </li>
                            <li>
                              <v-checkbox
                                v-model="selected_known"
                                label="現地看板"
                                value="現地看板"
                                hide-details
                              ></v-checkbox>
                            </li>
                            <li class="even">
                              <v-checkbox
                                v-model="selected_known"
                                label="ロードサイド看板"
                                value="ロードサイド看板"
                                hide-details
                              ></v-checkbox>
                            </li>
                            <li class="last">
                              <v-checkbox
                                v-model="selected_known"
                                label="交通広告"
                                value="交通広告"
                                hide-details
                              ></v-checkbox>
                            </li>
                          </ul>
                        </li>

                        <li class="pT15 even">
                          <ul>
                            <li class="ttl first">
                              <p>■紹介</p>
                            </li>
                            <li class="even">
                              <v-checkbox
                                v-model="selected_known"
                                label="勤務先紹介"
                                value="勤務先紹介"
                                hide-details
                              ></v-checkbox>
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <div
                        class="v-text-field__details"
                        v-show="selected_known.length == 0"
                      >
                        <div
                          class="v-messages theme--light error--text"
                          role="alert"
                        >
                          <div class="v-messages__wrapper">
                            <div
                              class="
                                v-messages__message
                                message-transition-enter-to
                              "
                            >
                              選択してください
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="YellowBox btm15">ご要望・ご質問</p>
            <div class="bscTbl01 btm30">
              <table width="100%" border="0">
                <tbody>
                  <tr class="last">
                    <th scope="row" class="w30 pb-5">
                      その他ご要望・ご質問など
                    </th>
                    <td>
                      <v-textarea
                        v-model="etc"
                        label="その他ご要望・ご質問など"
                        outlined
                        rows="8"
                      ></v-textarea>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="policyArea">
              <h3 class="mb10">利用規約</h3>
              <div id="rule">
                <div class="rule-section">
                  <h3>第1条（本サービスについて）</h3>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）利用者は本サービス利用にあたり、自己の責任と負担において通信機器、ソフトウェア、回線環境等設備を用意するものとします。
                    </li>
                    <li class="even last">
                      （2）本サービスは、本サイトを通して行う情報の提供、およびその他の情報の提供から構成されます。
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第2条（本規約の変更）</h3>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）当社は、利用者の承諾を得ることなく、当社が定める方法により、本規約を変更することができるものとします。この場合、提供条件等は変更後の規約によります。
                    </li>
                    <li class="even last">
                      （2）変更後の規約は、当社が変更内容を本サービスのページ上に掲示した時点から効力を有するものとします。
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第3条（当社からの通知）</h3>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）
                      当社は、本サービスのページへの掲示、その他当社が適当と判断する方法・範囲で、利用者が本サービスを利用するうえで必要な事項を通知するものとします。
                    </li>
                    <li class="even last">
                      （2）
                      前項に定める通知は、当社が当該通知の内容を、本サービスのページに掲示した時点から効力を有するものとします。
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第4条（著作権）</h3>
                  <p>
                    本サービスにおいて当社が提供するページ等のコンテンツ、画面デザインその他一切の著作物の著作権は、当社又は当社が定める者に帰属するものとします。
                  </p>
                </div>
                <div class="rule-section">
                  <h3>第5条（利用契約の締結等）</h3>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）
                      利用者は、本サービスを利用するにあたり必要な情報を入力、当社宛に発信することにより本サービスの申し込みをするものとし、当該発信情報が本サービスのサーバに格納された時点で、利用契約が成立するものとします。
                    </li>
                    <li class="even last">
                      （2）
                      当社は、前項その他本規約の規定にかかわらず、利用者が次のいずれかに該当する場合には、利用契約を締結しないことがあります。
                      <ul class="UL_PRIVACY">
                        <li class="first">
                          1.
                          本サービスの申し込みをした方が実在しないことが判明したとき
                        </li>
                        <li class="even">
                          2.本サービスの申し込み時に、虚偽の入力、入力誤りがあったとき又は入力もれがあったとき
                        </li>
                        <li class="last">
                          3. その他、当社が不適当と判断したとき
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第6条（本サービスの料金）</h3>
                  <p>本サービスの利用料金は、無料とします。</p>
                </div>
                <div class="rule-section">
                  <h3>第7条（中断・廃止）</h3>
                  <p>
                    当社は、次のいずれかに該当すると判断した場合、利用者への事前の連絡又は承諾を要することなく、本サービスを一時的に中断できるものとします。
                  </p>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）
                      本サービスの提供に必要な設備の故障等により保守を行う場合
                    </li>
                    <li class="even">
                      （2） 不可抗力により本サービスを提供できない場合
                    </li>
                    <li>
                      （3）
                      本サービスの提供に必要なデータのバックアップ等を行なう場合
                    </li>
                    <li class="even last">
                      （4） その他、運用上又は技術上の理由でやむを得ない場合
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第8条 （広告等）</h3>
                  <p>
                    当社は、本サービスのページ上に第三者の提供する広告を掲載することがあります。なお、当該広告は広告提供者の責任で掲載されるものであって、当社はその正確性、適法性等について保証するものではなく、一切責任を負わないものとします。
                  </p>
                </div>
                <div class="rule-section">
                  <h3>第9条（個人情報）</h3>
                  <p>
                    当社は、本サービスにおける個人を特定する情報(以下｢個人情報｣といいます。)は、以下のとおり取り扱うものとします。
                  </p>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1） 当社取扱商品に関するご連絡、ご通知、資料送付の為
                    </li>
                    <li class="even">（2） 当社からの情報提供の為</li>
                    <li>
                      （3）
                      当社取扱商品の情報、キャンペーン情報（広告含む）のご案内、資料送付の為
                    </li>
                    <li class="even">
                      （4）
                      お問合せいただいた「ご質問・ご意見等」に対して、当社よりご連絡をさせていただく為
                    </li>
                    <li>
                      （5）
                      本サービスのご利用においてのお問合せ・発生したトラブル等に対して、当社よりご連絡させていただく為
                    </li>
                    <li class="even">
                      （6） 本サービスを円滑に運営する為に一定期間の保管をする為
                    </li>
                    <li class="last">
                      （7）
                      当社のマーケティングデータとして、個人が特定できない形での利用をする為
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第10条（禁止行為）</h3>
                  <p>
                    利用者は、本サービスの利用にあたり、次の各項に定める行為をしてはならないものとします。
                  </p>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1） 本サービスに関する情報を改ざんする行為
                    </li>
                    <li class="even">
                      （2） 利用者以外の者になりすまして本サービスを利用する行為
                    </li>
                    <li>
                      （3）
                      有害なコンピュータープログラム等を送信又は書き込む行為
                    </li>
                    <li class="even">
                      （4）
                      第三者又は当社の財産、名誉及びプライバシー等を侵害する行為
                    </li>
                    <li>
                      （5）
                      本人の同意を得ることなく又は詐欺的な手段により第三者又は当社の個人情報を収集する行為
                    </li>
                    <li class="even">
                      （6） 本サービスの利用又は提供を妨げる行為
                    </li>
                    <li>
                      （7）
                      当第三者又は当社の著作権その他の知的財産権を侵害する行為
                    </li>
                    <li class="even">（8） 法令又は公序良俗に反する行為</li>
                    <li>
                      （9）
                      本サービスを利用した営業活動その他営利を目的とする行為
                    </li>
                    <li class="even">
                      （10） 当社の信用を傷つけ、又は当社に損害を与える行為
                    </li>
                    <li class="last">
                      （11） その他、当社が不適切と判断した行為
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第11条（責任の範囲）</h3>
                  <p>
                    当社は、第5条又は次の各項に定める事由により、利用者又は第三者（他の利用者を含む）が損害を被った場合であっても、一切責任を負わないものとします。
                  </p>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）
                      利用者設備の不具合等により、本サービスを利用できなかった場合
                    </li>
                    <li class="even">（2） 利用者が本規約に違反した場合</li>
                    <li>
                      （3）
                      紛争又は損害の原因が当社の責に帰すべき事由による場合を除き、本サービスの利用によって利用者と第三者との間で紛争が生じた場合又は利用者が第三者に損害を与えた場合
                    </li>
                    <li class="even last">
                      （4）
                      その他本サービスを利用することにより、当社の責によらずして利用者又は第三者に損害が発生した場合
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第12条（本規約に定めのない事項）</h3>
                  <p>
                    本規約に定めのない事項その他本規約の条項に関し疑義を生じたときは、協議のうえ円満に解決を図るものとします。
                  </p>
                </div>
                <div class="rule-section">
                  <h3>第13条（問合せ先）</h3>
                  <p>
                    本サービスにかかる問合せ先は、以下の通りです。<br />
                    株式会社ハウスフリーダム 電話：072-336-0503
                    FAX：072-337-7781<br /><br />
                    ■基本方針の改訂・変更<br />
                    本基本方針は法令などの制定改廃や情勢の変化により適宜変更します。
                  </p>
                </div>
              </div>
            </div>

            <div class="formtxt">
              <p class="btm30">
                《個人情報のお取り扱いについて》 <br />
                送信していただくお客様の個人情報は、当社の個人情報保護方針に基づき厳重に管理し、
                <br />
                適切にお取り扱いいたします。
              </p>
              <p class="top30 btm30">
                上記「利用規約」の内容および、<br />当社事業に関する情報を電子メールにて受け取ることに同意される方は<br />下記「確認画面へ進む」のボタンを押してください。
              </p>
            </div>

            <p class="subscribeBtn">
              <v-btn
                depressed
                color="primary"
                style="font-size: 2rem"
                @click="submit()"
              >
                確認画面へ進む
              </v-btn>
            </p>
          </v-form>
        </div>
      </section>
      <!--/section-->
    </div>
    <transition name="fade">
      <div
        id="waiting"
        style="position: absolute; top: 0; left: 0; width: 100vw; height: 100vh"
        v-show="status == 2"
      >
        <v-container fill-height>
          <v-layout row justify-center align-center>
            <v-progress-circular
              indeterminate
              :size="70"
              :width="7"
              color="purple"
            ></v-progress-circular>
          </v-layout>
        </v-container>
      </div>
    </transition>
    <div id="confirm" v-if="status == 3">
      <section class="last">
        <div class="scInr">
          <div class="ContentTitle pt-6">
            <h2 class="head01" data-text="Contact">資料請求・来場予約</h2>
            <div class="titleafter">
              <img src="/image/title.png" />
            </div>
          </div>
          <p>
            <span class="Req">[※必須]</span
            >は、必須項目です。記入漏れがないか確認の上、ご送信ください。 <br />
            お送りいただく情報は、SSL(セキュア・ソケット・レイヤー)暗号化技術により保護されております。
          </p>
          <p class="YellowBox btm15">先にお選びください。</p>
          <v-form name="form2" id="form2" ref="form2">
            <div class="bscTbl01 btm30">
              <table width="100%" border="0">
                <tbody>
                  <tr class="last">
                    <th scope="row" class="w30 pb-5">
                      選択項目<span class="Req">[※必須]</span>
                    </th>
                    <td class="pb-5">
                      <div class="fltList02">
                        <span class="text-h5"> {{ sentaku }} </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="YellowBox btm15">お客様情報のご入力をお願いします。</p>

            <div class="bscTbl01 btm30">
              <table width="100%" border="0">
                <tbody>
                  <tr id="firstNotice" v-show="sentaku == '来場予約'">
                    <th scope="row" class="w30 pb-5">
                      来場希望日<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc">
                      <div class="fltList02 pb-5">
                        <span class="text-h5">
                          第一希望日：{{ date }} {{ hh1 }}:{{ mm1 }}
                        </span>
                        <span class="text-h5">
                          第二希望日：{{ date2 }} {{ hh2 }}:{{ mm2 }}
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr class="even">
                    <th scope="row" class="pb-5">
                      お名前<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc pb-5">
                      <p class="btm5">
                        <span class="text-h5"> {{ sei }} {{ mei }} </span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="pb-5">
                      フリガナ<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc pb-5">
                      <p class="btm5">
                        <span class="text-h5">
                          {{ sei_kana }} {{ mei_kana }}
                        </span>
                      </p>
                    </td>
                  </tr>
                  <tr class="even">
                    <th scope="col" class="pb-5">
                      ご住所<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc pb-5">
                      <span class="text-h5"> 〒{{ zipcode }} </span>
                      <span class="text-h5">
                        {{ addr1 }} {{ addr2 }} {{ addr3 }} {{ addr4 }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="pb-5">
                      お電話番号<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc pb-5">
                      <span class="text-h5"> {{ tel }} </span>
                    </td>
                  </tr>
                  <tr class="even">
                    <th scope="row" class="pb-5">
                      メールアドレス<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc pb-5">
                      <span class="text-h5"> {{ email }} </span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="pb-5">
                      年齢<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc pb-5">
                      <span class="text-h5"> {{ age }} </span>
                    </td>
                  </tr>
                  <tr class="even last">
                    <th scope="row" class="w30 pb-5">
                      このホームページをどのようにお知りになりましたか？
                      <br />※複数選択<span class="Req">[※必須]</span>
                    </th>
                    <td class="nc">
                      <ul>
                        <li v-for="item in selected_known" :key="item">
                          <span class="text-h5"> {{ item }}</span>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="YellowBox btm15">ご要望・ご質問</p>
            <div class="bscTbl01 btm30">
              <table width="100%" border="0">
                <tbody>
                  <tr class="last">
                    <th scope="row" class="w30 pb-5">
                      その他ご要望・ご質問など
                    </th>
                    <td class="pb-5">
                      <span class="text-h5"> {{ etc }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="policyArea">
              <h3 class="mb10">利用規約</h3>
              <div id="rule">
                <div class="rule-section">
                  <h3>第1条（本サービスについて）</h3>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）利用者は本サービス利用にあたり、自己の責任と負担において通信機器、ソフトウェア、回線環境等設備を用意するものとします。
                    </li>
                    <li class="even last">
                      （2）本サービスは、本サイトを通して行う情報の提供、およびその他の情報の提供から構成されます。
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第2条（本規約の変更）</h3>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）当社は、利用者の承諾を得ることなく、当社が定める方法により、本規約を変更することができるものとします。この場合、提供条件等は変更後の規約によります。
                    </li>
                    <li class="even last">
                      （2）変更後の規約は、当社が変更内容を本サービスのページ上に掲示した時点から効力を有するものとします。
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第3条（当社からの通知）</h3>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）
                      当社は、本サービスのページへの掲示、その他当社が適当と判断する方法・範囲で、利用者が本サービスを利用するうえで必要な事項を通知するものとします。
                    </li>
                    <li class="even last">
                      （2）
                      前項に定める通知は、当社が当該通知の内容を、本サービスのページに掲示した時点から効力を有するものとします。
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第4条（著作権）</h3>
                  <p>
                    本サービスにおいて当社が提供するページ等のコンテンツ、画面デザインその他一切の著作物の著作権は、当社又は当社が定める者に帰属するものとします。
                  </p>
                </div>
                <div class="rule-section">
                  <h3>第5条（利用契約の締結等）</h3>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）
                      利用者は、本サービスを利用するにあたり必要な情報を入力、当社宛に発信することにより本サービスの申し込みをするものとし、当該発信情報が本サービスのサーバに格納された時点で、利用契約が成立するものとします。
                    </li>
                    <li class="even last">
                      （2）
                      当社は、前項その他本規約の規定にかかわらず、利用者が次のいずれかに該当する場合には、利用契約を締結しないことがあります。
                      <ul class="UL_PRIVACY">
                        <li class="first">
                          1.
                          本サービスの申し込みをした方が実在しないことが判明したとき
                        </li>
                        <li class="even">
                          2.本サービスの申し込み時に、虚偽の入力、入力誤りがあったとき又は入力もれがあったとき
                        </li>
                        <li class="last">
                          3. その他、当社が不適当と判断したとき
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第6条（本サービスの料金）</h3>
                  <p>本サービスの利用料金は、無料とします。</p>
                </div>
                <div class="rule-section">
                  <h3>第7条（中断・廃止）</h3>
                  <p>
                    当社は、次のいずれかに該当すると判断した場合、利用者への事前の連絡又は承諾を要することなく、本サービスを一時的に中断できるものとします。
                  </p>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）
                      本サービスの提供に必要な設備の故障等により保守を行う場合
                    </li>
                    <li class="even">
                      （2） 不可抗力により本サービスを提供できない場合
                    </li>
                    <li>
                      （3）
                      本サービスの提供に必要なデータのバックアップ等を行なう場合
                    </li>
                    <li class="even last">
                      （4） その他、運用上又は技術上の理由でやむを得ない場合
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第8条 （広告等）</h3>
                  <p>
                    当社は、本サービスのページ上に第三者の提供する広告を掲載することがあります。なお、当該広告は広告提供者の責任で掲載されるものであって、当社はその正確性、適法性等について保証するものではなく、一切責任を負わないものとします。
                  </p>
                </div>
                <div class="rule-section">
                  <h3>第9条（個人情報）</h3>
                  <p>
                    当社は、本サービスにおける個人を特定する情報(以下｢個人情報｣といいます。)は、以下のとおり取り扱うものとします。
                  </p>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1） 当社取扱商品に関するご連絡、ご通知、資料送付の為
                    </li>
                    <li class="even">（2） 当社からの情報提供の為</li>
                    <li>
                      （3）
                      当社取扱商品の情報、キャンペーン情報（広告含む）のご案内、資料送付の為
                    </li>
                    <li class="even">
                      （4）
                      お問合せいただいた「ご質問・ご意見等」に対して、当社よりご連絡をさせていただく為
                    </li>
                    <li>
                      （5）
                      本サービスのご利用においてのお問合せ・発生したトラブル等に対して、当社よりご連絡させていただく為
                    </li>
                    <li class="even">
                      （6） 本サービスを円滑に運営する為に一定期間の保管をする為
                    </li>
                    <li class="last">
                      （7）
                      当社のマーケティングデータとして、個人が特定できない形での利用をする為
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第10条（禁止行為）</h3>
                  <p>
                    利用者は、本サービスの利用にあたり、次の各項に定める行為をしてはならないものとします。
                  </p>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1） 本サービスに関する情報を改ざんする行為
                    </li>
                    <li class="even">
                      （2） 利用者以外の者になりすまして本サービスを利用する行為
                    </li>
                    <li>
                      （3）
                      有害なコンピュータープログラム等を送信又は書き込む行為
                    </li>
                    <li class="even">
                      （4）
                      第三者又は当社の財産、名誉及びプライバシー等を侵害する行為
                    </li>
                    <li>
                      （5）
                      本人の同意を得ることなく又は詐欺的な手段により第三者又は当社の個人情報を収集する行為
                    </li>
                    <li class="even">
                      （6） 本サービスの利用又は提供を妨げる行為
                    </li>
                    <li>
                      （7）
                      当第三者又は当社の著作権その他の知的財産権を侵害する行為
                    </li>
                    <li class="even">（8） 法令又は公序良俗に反する行為</li>
                    <li>
                      （9）
                      本サービスを利用した営業活動その他営利を目的とする行為
                    </li>
                    <li class="even">
                      （10） 当社の信用を傷つけ、又は当社に損害を与える行為
                    </li>
                    <li class="last">
                      （11） その他、当社が不適切と判断した行為
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第11条（責任の範囲）</h3>
                  <p>
                    当社は、第5条又は次の各項に定める事由により、利用者又は第三者（他の利用者を含む）が損害を被った場合であっても、一切責任を負わないものとします。
                  </p>
                  <ul class="UL_PRIVACY">
                    <li class="first">
                      （1）
                      利用者設備の不具合等により、本サービスを利用できなかった場合
                    </li>
                    <li class="even">（2） 利用者が本規約に違反した場合</li>
                    <li>
                      （3）
                      紛争又は損害の原因が当社の責に帰すべき事由による場合を除き、本サービスの利用によって利用者と第三者との間で紛争が生じた場合又は利用者が第三者に損害を与えた場合
                    </li>
                    <li class="even last">
                      （4）
                      その他本サービスを利用することにより、当社の責によらずして利用者又は第三者に損害が発生した場合
                    </li>
                  </ul>
                </div>
                <div class="rule-section">
                  <h3>第12条（本規約に定めのない事項）</h3>
                  <p>
                    本規約に定めのない事項その他本規約の条項に関し疑義を生じたときは、協議のうえ円満に解決を図るものとします。
                  </p>
                </div>
                <div class="rule-section">
                  <h3>第13条（問合せ先）</h3>
                  <p>
                    本サービスにかかる問合せ先は、以下の通りです。<br />
                    株式会社ハウスフリーダム 電話：072-336-0503
                    FAX：072-337-7781<br /><br />
                    ■基本方針の改訂・変更<br />
                    本基本方針は法令などの制定改廃や情勢の変化により適宜変更します。
                  </p>
                </div>
              </div>
            </div>

            <div class="formtxt">
              <p class="btm30">
                《個人情報のお取り扱いについて》 <br />
                送信していただくお客様の個人情報は、当社の個人情報保護方針に基づき厳重に管理し、
                <br />
                適切にお取り扱いいたします。
              </p>
              <p class="top30 btm30">
                上記「利用規約」の内容および、<br />当社事業に関する情報を電子メールにて受け取ることに同意される方は<br />下記「送信する」のボタンを押してください。
              </p>
            </div>

            <p class="subscribeBtn">
              <v-btn
                depressed
                color="grey lighten-1"
                style="font-size: 2rem"
                @click="back()"
              >
                戻る
              </v-btn>
              <v-btn
                depressed
                color="primary"
                style="font-size: 2rem"
                @click="send()"
              >
                送信する
              </v-btn>
            </p>
          </v-form>
        </div>
      </section>
      <!--/section-->
    </div>
    <div id="end" v-if="status == 4">
      <section class="last">
        <div class="scInr">
          <div class="ContentTitle">
            <h2 class="head01" data-text="Contact">
              フォームの送信が完了しました
            </h2>
            <div class="titleafter"><img src="/image/title.png" /></div>
          </div>

          <p class="btm20 center">
            ご入力いただいたメールアドレス宛に確認のメールをお送りしましたのでご確認ください。<br />
            また、お問い合わせ内容に関しましては、追って担当者よりご連絡させていただきますので、<br />
            今しばらくお待ちくださいませ。
          </p>
          <div class="bscBox02 btm20">
            <p class="center">
              ※確認メールが届かない場合、送信エラーの可能性がございます。<br />
              その際はお手数ですが、もう一度初めからご入力をお願いいたします。
            </p>
          </div>

          <p class="bscBtn02 center">
            <a href="https://www.housefreedom.co.jp/"
              >TOPへ戻る<i class="icon-angle-right"></i
            ></a>
          </p>
        </div>
      </section>
    </div>
    <v-snackbar v-model="snackbar" color="red" timeout="2000">
      エラーがあります。ご確認ください。

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-main>
</template>

<script>
export default {
  data: () => ({
    status: 1,
    success: false,
    postdata: {},
    sentaku: "",
    sei: "",
    mei: "",
    sei_kana: "",
    mei_kana: "",
    zipcode: "",
    addr1: "",
    addr2: "",
    addr3: "",
    addr4: "",
    tel: "",
    email: "",
    age: "",
    etc: "",
    menu: false,
    date: "",
    hh1: "",
    mm1: "",
    menu2: false,
    date2: "",
    hh2: "",
    mm2: "",
    snackbar: false,
    todoufuken_list: [
      "北海道",
      "青森県",
      "岩手県",
      "宮城県",
      "秋田県",
      "山形県",
      "福島県",
      "茨城県",
      "栃木県",
      "群馬県",
      "埼玉県",
      "千葉県",
      "東京都",
      "神奈川県",
      "新潟県",
      "富山県",
      "石川県",
      "福井県",
      "山梨県",
      "長野県",
      "岐阜県",
      "静岡県",
      "愛知県",
      "三重県",
      "滋賀県",
      "京都府",
      "大阪府",
      "兵庫県",
      "奈良県",
      "和歌山県",
      "鳥取県",
      "島根県",
      "岡山県",
      "広島県",
      "山口県",
      "徳島県",
      "香川県",
      "愛媛県",
      "高知県",
      "福岡県",
      "佐賀県",
      "長崎県",
      "熊本県",
      "大分県",
      "宮崎県",
      "鹿児島県",
      "沖縄県",
    ],
    hh_lists: ["10", "11", "12", "13", "14", "15", "16", "17", "18"],
    mm_lists: ["00", "30"],
    selected_known: [],
    required: (value) => !!value || "必ず入力してください", // 入力必須の制約
    limit_20: (value) =>
      (value || "").length <= 20 || "20文字以内で入力してください",
    limit_7: [
      (value) => {
        const pattern = /^\d{7}$/;
        return pattern.test(value) || "7文字で入力してください";
      },
    ],
    numberonly: [
      (value) => {
        const pattern = /^\d+$/;
        return pattern.test(value) || "数字のみで入力してください";
      },
    ],
    emailonly: [
      (value) => {
        const pattern =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "emailを入力してください";
      },
    ],
  }),
  created: function () {},
  mounted: function () {
    let path = this.$route.fullPath;
    if (path.indexOf("?document") >= 0) {
      this.sentaku = "資料請求";
    }
    if (path.indexOf("?reservation") >= 0) {
      this.sentaku = "来場予約";
    }
  },
  methods: {
    required_if_raijyou(value) {
      if (this.sentaku != "来場予約") {
        return true;
      }
      if (!value) {
        return "必ず入力してください";
      }
      return true;
    },
    allowedDate: function (val) {
      // 今日～100日後までを選べるようにする
      let today = new Date();
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      let maxAllowedDay = new Date();
      maxAllowedDay.setDate(today.getDate() + 100);
      maxAllowedDay = new Date(
        maxAllowedDay.getFullYear(),
        maxAllowedDay.getMonth(),
        maxAllowedDay.getDate()
      );
      return today <= new Date(val) && new Date(val) <= maxAllowedDay;
    },
    submit() {
      // ↓***** 新規追加 & 修正
      if (this.$refs["form"].validate() && this.selected_known.length != 0) {
        // すべてのバリデーションが通過したときのみ
        // if文の中に入る
        this.success = true;
        this.status = 2;
        window.setTimeout(() => {
          this.status = 3;
          this.$vuetify.goTo(0);
        }, 1000);
      } else {
        this.success = false;
        this.snackbar = true;
      }
      // ↑***** 新規追加 & 修正
    },
    back() {
      this.success = false;
      this.status = 2;
      window.setTimeout(() => {
        this.status = 1;
        this.$vuetify.goTo(0);
      }, 1000);
    },
    send() {
      if (this.status != 3) {
        return;
      }
      this.status = 2;
      this.postdata = {};
      this.postdata.sei = this.sei;
      this.postdata.mei = this.mei;
      this.postdata.sei_kana = this.sei_kana;
      this.postdata.mei_kana = this.mei_kana;
      this.postdata.sentaku = this.sentaku;
      this.postdata.zipcode = this.zipcode;
      this.postdata.addr1 = this.addr1;
      this.postdata.addr2 = this.addr2;
      this.postdata.addr3 = this.addr3;
      this.postdata.addr4 = this.addr4;
      this.postdata.tel = this.tel;
      this.postdata.email = this.email;
      this.postdata.age = this.age;
      this.postdata.etc = this.etc;
      this.postdata.date = this.date;
      this.postdata.hh1 = this.hh1;
      this.postdata.mm1 = this.mm1;
      this.postdata.date2 = this.date2;
      this.postdata.hh2 = this.hh2;
      this.postdata.mm2 = this.mm2;
      this.postdata.selected_known = this.selected_known;

      this.axios
        .post("/api/sendgrid/", {
          item: this.postdata,
        })
        .then((response) => {
          console.log("success");
          console.log(response);
          if (this.sentaku == "資料請求") {
            this.$router.push({ name: "contact-thx-document" });
          } else {
            this.$router.push({ name: "contact-thx-reservation" });
          }
        })
        .catch((error) => console.log(error));
    },
    getaddress() {
      this.axios
        .post("/api/address/", {
          item: this.zipcode,
        })
        .then((response) => {
          console.log("success");
          console.log(response);
          let res = response.data;
          this.addr1 = res.addr1;
          this.addr2 = res.addr2;
          this.addr3 = res.addr3;
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>
<style>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.v-application {
  font-family: inherit !important;
}
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.v-application ol,
.v-application ul {
  padding-left: 0px !important;
}
.v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
  font-size: 1.2rem !important;
  font-weight: 500 !important;
  line-height: 1.2rem !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter {
  transform: translateY(15px);
}
</style>